<template>
  <div class="list-box">
    <div class="nav gap-x-3" title="" data-title="客户管理">
      <el-input
        v-model="state.params.keywords"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
      <el-button
        type="primary"
        icon="Plus"
        @click="
          delete state.selectId;
          state.showInfo = true;
        "
      >
        新建
      </el-button>
    </div>
    <div class="content c-table-box mt-2">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) =>
              $buildTabIndex(state.params.page, state.params.limit, index)
          "
          align="center"
        />
        <el-table-column label="名称" prop="name" />
        <el-table-column label="描述" prop="description" />
        <el-table-column label="创建人">
          <template #default="{ row }">
            <div>
              <text>{{ row.add_admin?.admin_name }}</text>
              <text class="text-gray-400 text-xs ml-1">{{
                row.add_admin?.department_name
              }}</text>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" prop="create_time" />
        <el-table-column
          label="修改时间"
          prop="update_time"
          :formatter="$tab_TextFormat"
        />
        <el-table-column label="状态" fixed="right" :width="120">
          <template #default="{ row }">
            <el-switch
              v-model="row.status"
              active-text="启用"
              inactive-text="禁用"
              :active-value="1"
              :inactive-value="0"
              :disabled="!row.id"
              inline-prompt
              @change="onUpdateStatus($event, row)"
            />
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" :width="320">
          <template #default="{ row }">
            <el-button
              type="warning"
              :icon="Edit"
              link
              @click="
                state.selectId = row.id;
                state.showInfo = true;
              "
              >编辑
            </el-button>
            <el-button
              type="success"
              :icon="Connection"
              link
              @click="
                state.role_id = row.id;
                state.showBind = true;
              "
              >绑定用户
            </el-button>
            <el-button
              type="warning"
              :icon="Check"
              link
              @click="
                state.auth_id = row.id;
                state.showAuth = true;
              "
              >授权
            </el-button>
            <el-button type="danger" :icon="Delete" link @click="onDelete(row)"
              >删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
  </div>
  <el-dialog
    v-model="state.showInfo"
    :title="state.selectId ? '编辑角色' : '新建角色'"
    class="c-el-dialog"
    width="500"
    :before-close="
      () => {
        state.showInfo = false;
      }
    "
  >
    <c_info
      :id="state.selectId"
      @close="
        (refresh) => {
          state.showInfo = false;
          if (refresh) onLoad();
        }
      "
    />
  </el-dialog>
  <el-drawer v-model="state.showAuth" :with-header="false" size="80%">
    <c_auth
      :id="state.auth_id"
      :key="state.auth_id"
      @close="state.showAuth = false"
    ></c_auth>
  </el-drawer>
  <el-drawer v-model="state.showBind" :with-header="false" size="80%">
    <c_bind
      :role_id="state.role_id"
      :key="state.role_id"
      @close="state.showBind = false"
    ></c_bind>
  </el-drawer>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  adminRole_page,
  adminRole_delete,
  adminRole_updateStatus,
} from "@/http/adminRole";
import { onDeleteConfirm, post_response } from "@/utils/funcs";
import { ElMessageBox } from "element-plus";

import c_info from "./Info.vue";
import c_auth from "./Auth.vue";
import c_bind from "./Bind.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  components: {
    c_info,
    c_auth,
    c_bind,
  },
  setup() {
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      onLoad();
    });

    const onLoad = () => {
      delete state.bmData;

      adminRole_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //删除
    const onDelete = (row) => {
      onDeleteConfirm(adminRole_delete, row.id, onLoad, {
        filed: "角色",
        name: row.name,
      });
    };

    const onUpdateStatus = (value, row) => {
      ElMessageBox.confirm(
        `您确定${
          row.status == 1
            ? '<strong style="color: var(--el-color-success);">启用</strong>'
            : '<strong style="color: var(--el-color-danger);">禁用</strong>'
        }角色<strong style="font-weight:bold;color:#000">${
          row.name
        }</strong>吗？`,
        "状态变更",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          type: "warning",
          customClass: "c-delete-dialog",
          cancelButtonClass: "is-plain",
        },
      )
        .then(() => {
          adminRole_updateStatus({
            id: row.id,
            status: row.status,
          }).then((res) => {
            post_response(res, onLoad);
          });
        })
        .catch(() => {
          row.status = value ? 0 : 1;
        });
    };

    return { state, onLoad, onDelete, onUpdateStatus };
  },
};
</script>

<style lang="scss" scoped></style>
